export default function Menu(props) {
  const s = props?.size ?? 24;
  const c = props?.color ?? '#292D32';
  const stroke = props?.strokeWidth ?? 1.5;

  return (
    <svg width={s} height={s} viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2993 0.09166L20.1436 2.95936C20.5205 3.08163 20.849 3.32008 21.082 3.64054C21.3151 3.961 21.4406 4.34701 21.4408 4.74324V10.1292C21.4408 16.7651 17.3981 21.6043 11.3625 23.8834C10.9485 24.0389 10.4922 24.0389 10.0782 23.8834C4.04159 21.6053 0 16.7651 0 10.1292V4.74324C0 3.93063 0.524227 3.21022 1.29717 2.95936L10.1415 0.09166C10.5177 -0.0305533 10.923 -0.0305533 11.2993 0.09166V0.09166ZM10.6378 1.62039L1.79352 4.48916C1.73969 4.50642 1.69272 4.54032 1.65939 4.58598C1.62606 4.63164 1.60808 4.6867 1.60806 4.74324V10.1292C1.60806 15.9825 5.12434 20.2953 10.6453 22.3783C10.6937 22.3965 10.7471 22.3965 10.7954 22.3783C16.3164 20.2953 19.8327 15.9836 19.8327 10.1292V4.74324C19.8325 4.68674 19.8145 4.63176 19.7812 4.58613C19.7479 4.5405 19.701 4.50656 19.6473 4.48916L10.8029 1.62039C10.7492 1.60323 10.6915 1.60323 10.6378 1.62039V1.62039Z"
        fill={c}
      />
    </svg>
  );
}
